// src/hooks/useFeatureGate.js
import { useState, useCallback } from 'react';
import { usePlanAccess } from './usePlanAccess';

export function useFeatureGate() {
  const { hasAccess, tier, planLabel, planColor } = usePlanAccess();
  const [blockedFeature, setBlockedFeature] = useState(null);

  /**
   * Tenta acessar uma feature.
   * - Se tiver permissão: retorna true (libera a ação)
   * - Se NÃO tiver: abre o modal de upgrade e retorna false
   */
  const checkAccess = useCallback(
    (featureKey) => {
      if (hasAccess(featureKey)) return true;
      setBlockedFeature(featureKey);
      return false;
    },
    [hasAccess]
  );

  const closeModal = () => setBlockedFeature(null);

  return {
    tier,
    planLabel,
    planColor,
    blockedFeature,
    checkAccess,
    closeModal,
    isAllowed: hasAccess,
  };
}
